import { toastr } from 'react-redux-toastr'
import axios from 'axios'
import { getConfig, getUserToken } from '../util/helper';

export async function gerarCodigoMfa(values, config) {
    
    const cfg = await getConfig('mfa');
    const body = {
        "idUsuario": values.IdUsuario,
        "usuario": values.Usuario,
        "email": values.Email
    }
    try {
        //console.log(`MFA RESULTADO 0: ${cfg.baseUrl}/otp/gerar-auth`)
        const resultado = await axios.post(`${cfg.baseUrl}/otp/gerar-auth`, body, {
            headers: {
                'x-api-key': config.Valor,
                'Content-Type': 'application/json'
            }
        })
        //console.log('MFA RESULTADO 1: '+resultado)
        if (resultado) {
            return resultado.data;
        }
    } catch (error) {
        toastr.error('Não foi possível gerar código!')
        // toastr.error('Erro inesperado.', error)
        //console.log(error)
    }
}

export async function validaCodigoMfa(values, config) {
    //console.log('PASSAGEM -------- VALIDA COD')
    const cfg = await getConfig('mfa');
    //console.log('PASSAGEM -------- MFA validaCodigoMfa CONFIG')
    const body = {
        "idUsuario": values.IdUsuario,
        "codigo": values.codigo,
    }
    try {
        const resultado = await axios.post(`${cfg.baseUrl}/otp/validar-auth`, body, {
            headers: {
                'x-api-key': config.Valor,
                'Content-Type': 'application/json'
            }
        })
        //console.log('PASSAGEM -------- antes resultado')
        if (resultado) {
            //console.log('PASSAGEM -------- depois resultado',resultado)
            return resultado;
        }else{
            throw 'Código Inválido!!';
        }

    } catch (error) {
        toastr.error('Código inválido!')
        //console.log(error)
    }
}